export interface Consents {
  ccpaSignal: boolean;
  geoRequiresSignal: boolean;
  gdprConsent: boolean;
  geoRequiresConsent: boolean;
}

export type ConsentResolvedCallback = (
  consents: Consents,
) => void | Promise<void>;

export enum PrivacyLaw {
  CCPA = "ccpa",
  GDPR = "gdpr",
  PIPL = "pipl",
  LGPD = "lgpd",
}
